
export function makeUserName(user: {first_name: string, last_name: string, email: string}): string {
    return `${user.first_name} ${user.last_name} (${user.email})`
}
